// loginFormFields.ts

import { BaseFieldConfig } from "../../../CommonElements/DynamicFieldRenderer";

export const loginFormFields: BaseFieldConfig[] = [
  {
    name: "email",
    label: "Email",
    type: "email",
    col: 12,
    placeholder: "Enter your email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    col: 12,
    placeholder: "Enter your password",
    withPasswordToggle: true,
  },
];
